export const appusers = {
  appusersSearch: 'Пошук'
}
